export default __webpack_public_path__ + "static/banner2-f6d7a2ac64b45b56580c6a8f39a0b6f9.png";